export default {"src":"/_next/static/media/ChinChin.cebdd0da.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};